const Colors = {
  backgroundColor: '#FAEDEA',
  hairTypeBackgroundColor: '#FCFAFA',
  targetBackgroundColor: '#FFF'
};

const retailStyle = ({ isSmall, backgroundColor, titleWidth = 200 }) => `
  <style>
    .container {
        display: flex;
        background-color: ${backgroundColor || Colors.backgroundColor};
        flex-direction: column;
        align-items: center;
    }

    .form-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .step-container {
        text-align: center;
        padding-top: 30px;
        padding-bottom: 35px;
        display: flex;
        gap: 10px;
        flex-direction: column;
    }
    .products-container {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: center;
        padding-bottom: 50px;
        max-width: ${isSmall ? '500px' : '1400px'};
         ${
           isSmall
             ? `column-gap: 10px; row-gap: 30px`
             : 'column-gap: 15px; row-gap: 30px;'
         }
    }
    .product-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 500px;
        /*justify-content: space-between;*/
    }
    .product-hair-type {
        width: 117px;
        height: 20px;
        border-radius: 3px;
        background: ${Colors.hairTypeBackgroundColor};
        text-align: center;
    }
    .product-image {
        width: ${isSmall ? '200px' : '300px'};
        height: ${isSmall ? '200px' : '300px'};
    }
    .product-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /*gap: 4px;*/
        max-width: ${isSmall ? '196px' : '265px'};
        text-align: center;
    }

    .product-title {
        overflow: hidden;
        font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
        width: ${titleWidth}px;
        ${
          isSmall
            ? 'font-size: 18px;font-weight: 400;letter-spacing: .54px;line-height: 28px;'
            : ' font-size: 21px;letter-spacing: 0;line-height: 36px;'
        }



        ${isSmall ? 'max-height: 55px;width: 180px;' : 'height: 70px;'};


    }

    .product-price {
        font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: bold;
        line-height: 20px;
        letter-spacing: 0.28px;
    }

    .button-container {
        padding-top: 8px;

    }
    .product-button {
        border-radius: 3px;
    }

    .product-button[disabled] {
        background-color: #e6e8e8;
        color: #717575;
        opacity: 1;
        -moz-opacity: 1;
    }

    .product-button[disabled]:hover {
        background-color: #e6e8e8 !important;
        color: #717575 !important;
        opacity: 1;
        -moz-opacity: 1;
    }

    .middle-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /*padding-left: 10%;*/
        /*padding-right: 10%;*/
        padding-bottom: 56px;
        gap: 20px;
        width: 100%;
    }
    .middle-text {
    }
    .middle-image {
        background-repeat: no-repeat;
        background-size: contain;
        width: 100%;
        height: 320px;
        background-position: center;
    }


    .goals-container {
        display: flex;
    }

    .step-title {
        font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 55px;
        font-style: normal;
        font-weight: 300;
        line-height: 60px;
    }

    .step-sub-title  {
        font-size: 14px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        letter-spacing: 0.28px !important;
    }

    product-card {
      height: 100%;
      width: auto;
    }

    @media screen and (min-width: 1025px) {
        .step-sub-title {
            font-size: 20px !important;
            font-style: normal !important;
            font-weight: 400 !important;
            line-height: 40px !important;
        }
    }
}

  </style>
`;
export default retailStyle;

export { Colors };
